export default __webpack_public_path__ + "de414d72bdeced1333f3baabe4d236dc.svg";